<div class="calendar-container">
  <!-- Top bar -->
  <div class="top-bar">
    <div class="tab-pane left">
      <button class="active">Facility</button>
      <button (click)="goToCountFlow()">Timeslot</button>
    </div>
    <div class="logo-container">
      <img src="assets/img/logo_negative.png" alt="Logo" class="logo-img" />
    </div>
    <span class="username">Time registrering</span>
    <div class="user-info">
      <div class="logout"><button class="logout-button" (click)="logout()">Logout</button></div>
    </div>
  </div>

  <!-- Content area -->
  <div class="content">
    <!-- Chosen date label and calendar toggle -->
    <div class="date-label">
      <span class="selected-date-label">
        {{ selectedTime.getDate() }} {{ monthNames[selectedTime.getMonth()] }} {{ selectedTime.getFullYear() }}
      </span>
    </div>
    <div class="calendar-button">
      <button class="calendar-toggle" (click)="showCalendar = !showCalendar">
          <span *ngIf="!showCalendar">Change date</span>
          <span *ngIf="showCalendar">Hide calendar</span>
      </button>
    </div>

    <!-- Collapsible calendar -->
    <div *ngIf="showCalendar">
      <div class="month-navigation">
        <button class="nav-button" (click)="prevMonth()">&lt;</button>
        <span class="month-year">
          {{ monthNames[currentMonth] }} {{ currentYear }}
        </span>
        <button class="nav-button" (click)="nextMonth()" [disabled]="isNextMonthFuture()">&gt;</button>
      </div>
      <div class="calendar-grid">
        <div
          class="calendar-day"
          *ngFor="let day of daysInMonth"
          [class.selected]="day === selectedTime.getDate() && currentMonth === selectedTime.getMonth() && currentYear === selectedTime.getFullYear()"
          [class.disabled]="isFutureDay(day)"
          (click)="selectDayAndCollapse(day)"
          (keyup)="selectDayAndCollapse(day)"
          tabindex="0"
          [attr.aria-disabled]="isFutureDay(day)"
        >
          {{ day }}
        </div>
      </div>
    </div>

    <!-- Time selection row -->
    <div class="time-select-row">
      <button class="nav-button" (click)="decrementHour()" [disabled]="!canDecrementHour()">&lt;</button>
      <span class="selected-time-interval">
        {{ selectedTime | date: 'HH:mm' }} - {{ getIntervalEnd() | date: 'HH:mm' }}
      </span>
      <button class="nav-button" (click)="incrementHour()" [disabled]="!canIncrementHour() || isNextHourFuture()">&gt;</button>
    </div>

    <div class="bottom">
      <h3>Facilities</h3>
      <div *ngIf="isDetectionLoading" class="loading-indicator">Loading detections...</div>
      <div class="facility-list" *ngIf="!isDetectionLoading">
        <div
          class="facility-item"
          *ngFor="let facility of facilities"
        >
          <div class="facility-name">{{ facility.name }}</div>
          <div class="facility-count">
            <input
              class="detection-input-field"
              type="number"
              [value]="inputCounts[facility.id]"
              (input)="onCountInputChange(facility, $event)"
              placeholder="-"
              [disabled]="isFutureDay(selectedTime.getDate()) || isDetectionLoading || !canEditCounts(facility.id)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
